/* eslint-disable @next/next/no-img-element */
import { HoverSkew } from "../HoverSkew"
import { LargeHeading, Paragraph, Section } from "../misc"
import { ColorBlur } from "../ColorBlur"
import Link from "next/link"

export const Investors = () => {
  return (
    <Section className="text-center">
      <ColorBlur opacity={0.05}></ColorBlur>
      <div className="flex flex-col gap-1 text-center items-center pb-3">
        <Paragraph className="!max-w-[700px] !text-2xl !text-opacity-70">{`Our investors include:`}</Paragraph>
      </div>
      <HoverSkew className="!p-8 !px-14">
        <div className="flex flex-wrap gap-14 justify-center items-center">
          <a href="https://www.ycombinator.com/" target="_blank" rel="noreferrer">
            <img
              className="col-span-2 max-h-12 w-full object-contain lg:col-span-1 cursor-pointer"
              src="https://assets.website-files.com/61b63629f760bb842bf9c498/61b67d2f872d7a7a24e42737_logo-yc.png"
              alt="Y Combinator"
              style={{
                maxHeight: "2.2rem",
                width: "auto",
                margin: "0 auto",
              }}
            />
          </a>
          <a href="https://adjacent.com/" target="_blank" rel="noreferrer">
            <img
              className="col-span-2 max-h-12 w-full object-contain lg:col-span-1 cursor-pointer"
              src="https://assets.website-files.com/61b63629f760bb842bf9c498/61b67d2ea620207a425e41f2_logo-adjacent.png"
              alt="Adjacent"
              style={{
                maxHeight: "2rem",
                width: "auto",
                margin: "0 auto",
              }}
            />
          </a>
          <a href="https://www.weekend.fund/" target="_blank" rel="noreferrer">
            <img
              className="col-span-2 max-h-12 w-full object-contain sm:col-start-2 lg:col-span-1 cursor-pointer"
              src="https://assets.website-files.com/61b63629f760bb842bf9c498/61b67d2ff825cea147547bae_logo-weekent-fund.png"
              alt="Weekend Fund"
              style={{
                maxHeight: "1.9rem",
                width: "auto",
                margin: "0 auto",
              }}
            />
          </a>
          <a href="https://www.shrug.vc/" target="_blank" rel="noreferrer">
            <img
              className="col-span-2 col-start-2 max-h-12 w-full object-contain sm:col-start-auto lg:col-span-1 cursor-pointer"
              src="https://assets.website-files.com/61b63629f760bb842bf9c498/61b67d2ea7b7d75c59d68c59_logo-shrug.png"
              alt="Shrug VC"
              style={{
                maxHeight: "1.8rem",
                width: "auto",
                margin: "0 auto",
              }}
            />
          </a>
          <a href="https://www.revenuecat.com/" target="_blank" rel="noreferrer">
            <img
              className="col-span-2 max-h-12 w-full object-contain lg:col-span-1 cursor-pointer"
              src="https://assets.website-files.com/61b63629f760bb842bf9c498/61b67d2ee59dde01e8955c21_logo-revenuecat.png"
              alt="RevenueCat"
              style={{
                maxHeight: "2.25rem",
                transform: "translateY(10%)",
                width: "auto",
                margin: "0 auto",
              }}
            />
          </a>
        </div>
      </HoverSkew>
    </Section>
  )
}
